// Rótulo do aviso de falha no card do Kanban (`generation_error_message`, regra de `falha_de_geracao`
// no backend). Fora da ficha a mensagem é a de uma correção que falhou: o caso voltou à revisão com a
// versão de antes, e "Petição com pendências" falaria do portão dessa versão, não da falha (1.24).
export function generationIssueLabel(caso) {
  if (!caso.generation_error_message) return null;
  if (caso.status !== 'ficha_preenchimento') return 'Correção não concluída';
  return caso.quality_severity === 'critical' ? 'Petição com pendências' : 'Geração não concluída';
}
